// mobile application url
export const mobileAppUrl = "https://photo.pocr.io/";

// api base url
export const fileUploadUrl =
  "https://pocrdev1-core-webapi-apim.azure-api.net/pocrdev1-core-webapi";
export const webSocketUrl =
  "https://pocrdev1-core-webapi-apim.azure-api.net/pocrdev1-core-webapi/GetWsConnectionUrl?requestId=";
